import { render, staticRenderFns } from "./AdditionalBtnsWrapper.vue?vue&type=template&id=7fe9f055&scoped=true"
import script from "./AdditionalBtnsWrapper.vue?vue&type=script&lang=ts"
export * from "./AdditionalBtnsWrapper.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalBtnsWrapper.vue?vue&type=style&index=0&id=7fe9f055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9f055",
  null
  
)

export default component.exports